import { pxToRem } from '../../../../utils';
export var chatStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    return {
      backgroundColor: v.backgroundColor,
      border: siteVariables.borderWidth + " solid " + v.backgroundColor,
      display: 'flex',
      flexDirection: 'column',
      listStyle: 'none',
      margin: 0,
      padding: p.density === 'compact' ? "0 " + pxToRem(4) + " " + pxToRem(2) : "0 " + pxToRem(10) + " 0 " + pxToRem(10)
    };
  }
};